/* eslint-disable @next/next/no-img-element */
// EQUIPE "Grid destaque" (modelo_equipe = 3): grid de corretores com foto grande (3:4).
// No hover, um overlay sobe com nome, cargo, CRECI e botões WhatsApp/Instagram.
// No mobile as infos ficam SEMPRE visíveis (sem hover). Fundo cor5 com textos adaptativos.
import React from 'react';
import { FaInstagram, FaWhatsapp } from 'react-icons/fa';
import { SemFoto } from '../../../assets';
import { ensureReadableTextColor, isColorLight } from '../../../utils/FunctionsGlobals';
import { centralizaCardsDoSite } from '../../../utils/centralizarCardsPorSite';
import { paginaInternaAtelier } from '../../pieces/atelier/atelier';
import { trackLead } from '../../whatsAppButton/WhatsAppButton';
import { whatsCardEquipeImobiliaria } from '../../../utils/whatsappImobiliaria';
import styles from './ManagerGrid.module.css';

interface IManagerGrid {
    slides: Array<any>;
    title: string;
    site: any;
}

function handleImageError(event: React.SyntheticEvent<HTMLImageElement>) {
    const image = event.currentTarget;
    image.onerror = null;
    image.src = SemFoto.src;
}

const ManagerGrid: React.FC<IManagerGrid> = ({ slides, title, site }) => {
    const corFundo = site?.cor5 || '#f5f5f5';
    const corTexto = ensureReadableTextColor(isColorLight(corFundo) ? site?.cor11 : site?.cor13, corFundo) || '#1a1a1a';
    const corAcento = site?.cor2 || '#1f7a1f';

    const items = (slides || []).filter((s) => s?.id);
    if (!items.length) return null;

    const buildPhoto = (slide: any) => {
        const legacyPhoto = `https://fotos.sobressai.com.br/fotos/corretores/${site?.id}/${slide?.id}/${slide?.id}_g.jpg?v=${slide?.contador_atualizacao || 0}`;
        const storedPhoto = typeof slide?.url_foto === 'string' && slide.url_foto.trim() ? slide.url_foto.trim() : '';
        return storedPhoto || legacyPhoto;
    };

    const whatsHref = (slide: any) => {
        const clean = (slide?.telefone || '').replace(/\D/g, '');
        if (!clean) return '';
        return `https://api.whatsapp.com/send?phone=55${clean}&text=${encodeURIComponent(
            `Olá ${slide?.nome || ''}! Acessei o site da ${site?.Dados?.empresa || 'imobiliária'} e gostaria de mais informações.`
        )}`;
    };

    return (
        <section className={styles.section} style={{ background: corFundo, ['--mg-text' as any]: corTexto }}>
            <h3 className={styles.title} style={{ color: corTexto }}>
                {title}
            </h3>
            {/* Atelier (topo 12): equipe SEMPRE centralizada — linha incompleta (ex.: filial com 3 corretores)
                não encosta à esquerda (Daniel 14/10). Fora dele, só os codsites de centralizarCardsPorSite. */}
            <div className={centralizaCardsDoSite(site) || paginaInternaAtelier(site) ? `${styles.grid} ${styles.gridCentro}` : styles.grid}>
                {items.map((slide) => {
                    const whats = whatsCardEquipeImobiliaria(whatsHref(slide), site, slide, 'E');
                    return (
                        <article className={styles.card} key={slide?.id}>
                            <div className={styles.photoWrap}>
                                <img
                                    src={buildPhoto(slide)}
                                    alt={slide?.nome || 'Corretor'}
                                    className={styles.photo}
                                    loading="lazy"
                                    onError={handleImageError}
                                />
                                <div className={styles.overlay}>
                                    <p className={styles.name}>{slide?.nome}</p>
                                    {slide?.funcao?.nome ? <p className={styles.role}>{slide?.funcao?.nome}</p> : null}
                                    {slide?.creci ? <p className={styles.creci}>CRECI {slide?.creci}</p> : null}
                                    <div className={styles.actions}>
                                        {whats ? (
                                            <a
                                                href={whats}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className={styles.action}
                                                style={{ background: corAcento }}
                                                title={`Falar com ${slide?.nome || 'o corretor'} no WhatsApp`}
                                                aria-label={`WhatsApp de ${slide?.nome || 'corretor'}`}
                                                onClick={() => {
                                                    trackLead(site, null);
                                                }}
                                            >
                                                <FaWhatsapp aria-hidden="true" />
                                            </a>
                                        ) : null}
                                        {slide?.instagram ? (
                                            <a
                                                href={slide?.instagram}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className={styles.action}
                                                style={{ background: corAcento }}
                                                title={`Instagram de ${slide?.nome || 'corretor'}`}
                                                aria-label={`Instagram de ${slide?.nome || 'corretor'}`}
                                            >
                                                <FaInstagram aria-hidden="true" />
                                            </a>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        </article>
                    );
                })}
            </div>
        </section>
    );
};

export default ManagerGrid;
